<template>
    <div class="textarea__wrapper">
        <div class="textarea__container">
            <textarea :id="id"
                      ref="textarea"
                      :name="name"
                      :required="required"
                      :disabled="disabled"
                      :class="['textarea', modify]"
                      :value="value"
                      placeholder=" "
                      @focus="focus"
                      @input="$emit('input', $event.target.value)" />
            <label :for="id"
                   class="textarea__label"
                   v-html="label" />
            <span class="textarea__error"
                  v-html="error" />
            <span class="textarea__success">
                <IconCheckSmall />
            </span>
        </div>
    </div>
</template>

<script>
import IconCheckSmall from '@/components/Icons/CheckSmall';

export default {
    name: 'Textarea',

    components: {
        IconCheckSmall
    },

    model: {
        prop : 'value',
        event: 'input'
    },

    props: {
        id      : String,
        name    : String,
        label   : String,
        modify  : [Array, Object, String],
        value   : [String, Boolean, Number],
        required: {
            type   : Boolean,
            default: false
        },
        disabled: {
            type   : Boolean,
            default: false
        },
        isPassword: {
            type   : Boolean,
            default: false
        },
        error: {
            type   : String,
            default: 'Ошибка'
        }
    },

    data() {
        return {
            modelValue: null
        };
    },

    methods: {
        focus() {
            /**
             * Событие при фокусе инпута
             */
            this.$emit('focus');
        }
    }
};
</script>

<style lang="scss">
@import "Textarea";
</style>
